import * as moment from 'moment';
import { environment } from 'src/environments/environment';

export class SearchCriteria {
    checkIn: string | undefined;
    checkOut: string | undefined;
    rooms: IRoomRequest[] = [
        {
            adults: 2,
            children: 0,
            childAges: []
        }
    ];

    isSearchByHotel = false;

    locationId!: string;
    referenceId?: string;
    fullName: string | undefined;

    // selectedLocation: any;

    constructor(model?: SearchCriteria) {
        if (model) {
            if (model.checkIn && model.checkOut) {
                this.validateAndSetDates(model.checkIn, model.checkOut);
                model.checkIn = this.checkIn;
                model.checkOut = this.checkOut;
            }
            this.rooms = model.rooms;
            this.validateAndSetRooms();
            model.rooms = this.rooms;
            Object.assign(this, model);
        } else {
            this.getDefaultDates()
        }
    }

    validateDates(checkInDate: Date, checkOutDate: Date): boolean {
        checkInDate.setHours(0, 0, 0, 0);
        checkOutDate.setHours(0, 0, 0, 0);
        let currentDate: Date = new Date();
        currentDate.setHours(0, 0, 0, 0);
        return checkInDate >= currentDate && checkOutDate >= currentDate && checkOutDate > checkInDate;
    }

    validateAndSetDates(checkInDate: string, checkOutDate: string): SearchCriteria {
        if (this.validateDates(new Date(checkInDate), new Date(checkOutDate))) {
            this.checkIn = checkInDate;
            this.checkOut = checkOutDate;
        }
        else {
            this.getDefaultDates();
        }
        return this;
    }

    validateAndSetRooms(): SearchCriteria {
        if (this.rooms.length > 8) {
            console.log("Too many rooms");
            this.rooms = this.rooms.slice(0, 8);
        }

        if (this.rooms && this.rooms.length > 0) {
            this.rooms.forEach((room) => {

                //children and childAges mismatch:
                if (room.children && !room.childAges) {
                    room.children = 0;
                }
                if (room.childAges && !room.children) {
                    room.childAges = [];
                }
                if (room.children && room.childAges) {
                    if (room.children > room.childAges.length) {
                        room.children = room.childAges.length;
                    }
                    if (room.childAges.length > room.children) {
                        room.childAges.slice(0, room.children + 1)
                    }
                }

                if (room.adults > 8) {
                    console.log("Too many adults");
                    room.adults = 8;
                }
                if (room.childAges && room.childAges.length > 0) {
                    if (room.childAges.length > 4) {
                        console.log("Too many children");
                        room.children = 4;
                        room.childAges = room.childAges?.slice(0, 4);
                    }
                    room.childAges.forEach((childAge, index) => {
                        if (childAge > 17) {
                            console.log("child too old");
                            if (room.childAges) {
                                room.childAges[index] = 17;
                            }
                        }
                    })
                }
            })
        }
        else {
            this.rooms = [{
                adults: 2,
                children: 0,
                childAges: []
            }];
        }

        return this;
    }

    getDefaultDates() {
        let start = moment();
        if (start.hour() >= 0) {
            let offsetDate = 30;

            const str = JSON.parse(sessionStorage.getItem('SiteContext') || '{}');
            if (str && typeof str.checkInDateOffset === 'number') {
                offsetDate = str.checkInDateOffset;
            }
            start = moment().add(offsetDate, 'day');
        }
        this.checkIn = start.format('L');
        this.checkOut = moment(start).add(2, 'day').format('L'); // by default, booking for 2 days
    }

    toServiceModel() {
        var obj: any = {
            culture: 'en-us',
            currency: 'INR',
            checkIn: this.checkIn,
            checkOut: this.checkOut,
            rooms: this.rooms,
            countryOfResidence: environment.countryOfResidence,
            nationality: environment.nationality,
            locationId: this.locationId,
            fullName: this.fullName
        }

        return obj;
    }

    isSame(searchModel: any) {
        if (this.checkIn === searchModel.checkIn && this.checkOut === searchModel.checkOut
            && this.locationId === searchModel.locationId
            && this.getRoomString(this) === this.getRoomString(searchModel)) {
            return true;
        }

        return false;
    }

    getRoomString(searchModel: this) {
        let roominfo: any[] = []
        searchModel.rooms.forEach((room: any) => {
            let str = room.adults + '';
            if (room.children) {
                str += '-' + room.children;
                str += ':' + room.childAges.join(':');
            }
            roominfo.push(str);
        });
        return roominfo.join('_');
    }
}

export interface IRoomRequest {
    adults: number;
    children?: number;
    childAges?: number[];
    showError?: boolean;
}
